@defer (hydrate on immediate) {
	<div class="flex flex-col">
		<div class="relative">
			<div class="relative w-full z-[-999]">
				<img
					src="/assets/images/headers/desktop/header_acad_desktop.png"
					class="w-full h-[850px] object-cover hidden md:block"
					alt="Header Academy"
				/>
				<img
					src="/assets/images/headers/mobile/header_acad_mobile.png"
					class="w-full h-[850px] object-cover block md:hidden"
					alt="Header Academy"
				/>
			</div>
			<peps-separator></peps-separator>
		</div>
	</div>

	<div class="flex flex-col gap-20 mb-20">

		<div class="flex flex-col items-center gap-4 my-10 mx-auto p-8 w-10/12 md:w-9/12 2xl:w-6/12">
			<span class="uppercase text-[32px] text-peps-gold text-wrap text-center">{{ 'page.roster.academy.title' | translate }}</span>

			<p class="text-left font-notosans text-lg whitespace-pre-line">
				{{ 'page.roster.academy.description' | translate }}
			</p>
			<peps-button-small
				class="text-xl"
				[text]="'page.roster.academy.join-faceit' | translate"
				[hrefLink]="'https://fce.gg/peps-clubs'"
			></peps-button-small>
		</div>

		<div
			class="flex flex-row flex-wrap gap-8 mx-auto justify-center">
			@for(player of members$ | async; track player.id) {
				<peps-member-academy-card
					[member]="player"
				></peps-member-academy-card>
			}
		</div>

		<div class="flex flex-row flex-wrap gap-8 mx-auto justify-center">
			@for(player of coachesSubstitutes$ | async; track player.id) {
				<peps-member-academy-card
					[member]="player"
					[isSubstitute]="true"
				></peps-member-academy-card>
			}
		</div>

		<peps-achievement-row
			[achievements]="achievements"
		></peps-achievement-row>

		<div class="flex flex-col gap-10">

			<div class="flex flex-col md:flex-row justify-around items-center gap-4">
				<peps-title
					[subtitle]="'page.home.upcoming-matches.subtitle' | translate"
					[title]="'common.matches.lowercase' | translate"
				></peps-title>
				<span class="visible md:invisible"></span>
			</div>

			<peps-upcoming-matchs
				[matches]="matches"
			></peps-upcoming-matchs>

		</div>

	</div>
	<peps-last-videos></peps-last-videos>
}
